/**
 * デモモードの axios アダプタをグローバルに設置する。
 *
 * 一部のサービス（favoriteApi 等）は共有 axiosInstance ではなく生 axios を
 * 直接使うため、グローバルの既定アダプタを差し替えて全リクエストを捕捉する。
 * これは index.js の最初に import され、他サービスのインスタンス生成より前に実行される。
 *
 * DEMO_MODE=false のときは何もしないので、本番挙動には一切影響しない。
 */

import axios from 'axios';
import { DEMO_MODE } from '../config';
import { demoAdapter } from './demoAdapter';

if (DEMO_MODE) {
  axios.defaults.adapter = demoAdapter;
}

export {};
